<style lang="scss" scope>
.toolbar {
  @include border-bottom();
  margin-bottom: 10px;
  padding-bottom: 10px;
}
</style>
<template>
  <el-card shadow="never" class="l-main-card">
    <div class="l-container-sider">
      <l-org-list @on-before-check="loading = true" @on-after-check="aftercheckOrg"></l-org-list>
    </div>
    <!--右边菜单列表-->
    <div class="l-container-content" v-loading="loading">
      <div class="l-menu-box">
        <div class="l-container-title"><i class="el-icon-user-solid" /><b>人员管理</b></div>
        <div class="l-menu-list-main" style="bottom: 0; top: 30px">
          <div class="l-table-toolbar" style="text-align: right">
            <l-auth-button style="display:inline-block;margin-right:10px" type="primary" auth="admin_user_create_btn"
              @click="add_visible = true"> 新增</l-auth-button>
            <div class="input-with-select" style="display:inline-block;margin-right:10px">
              <el-input placeholder="姓名/ID" v-model="search_data.keywords" clearable>
                <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
              </el-input>
            </div>
          </div>
          <l-table :data="data" row-key="id" v-if="this.org_id == -1">
            <el-table-column v-for="(item, index) in columns" :key="index" v-bind="{ ...item }" :label="item.label"
              show-overflow-tooltip>

              <template v-slot="{ row }">
                <template v-if="item.prop == 'corp_name'">
                  <el-tag size="small" type="success" disable-transitions v-for="(item, idx) in row.corp_name" :key="idx">
                    {{ item }}
                  </el-tag>
                </template>
                <template v-else-if="item.prop == 'app_name'">
                  <el-tag size="small" type="success" disable-transitions v-for="(item, idx) in row.app_name" :key="idx">
                    {{ item }}
                  </el-tag>
                </template>
                <template v-else-if="item.prop == 'depart_name'">
                  <el-tag size="small" type="success" disable-transitions v-for="(item, idx) in row.depart_name"
                    :key="idx">
                    {{ item }}
                  </el-tag>
                </template>
                <template v-else-if="item.prop == 'group_name'">
                  <el-tag size="small" type="success" disable-transitions v-for="(item, idx) in row.group_name"
                    :key="idx">
                    {{ item }}
                  </el-tag>
                </template>
              <template v-else-if="item.prop == 'state'">
                <el-tag :type="row.state == STATES.enabled ? 'success' : 'danger'" size="small" disable-transitions>{{
                  STATE_NAMES[row.state] }}</el-tag>
                </template>
                <!-- <template v-else-if="item.prop == 'mobile'">
                        {{ phoneFormat(row.mobile) }}
                      </template> -->
                <template v-else>
                  {{ row[item.prop] }}
                </template>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="230" align="center">
              <template slot-scope="{ row }">
                <l-auth-text-button type="primary" auth="admin_user_info_btn" @click="showInfo(row.id)"><i
                    class="el-icon-warning-outline"></i>详情</l-auth-text-button>
                <span class="l-action-separator">|</span>
                <l-auth-text-button type="primary" auth="admin_user_edit_btn" @click="showEdit(row.id)"><i
                    class="el-icon-edit"></i>编辑</l-auth-text-button>
                <span class="l-action-separator">|</span>
                <l-auth-text-button type="danger" auth="admin_user_del_btn" @click="del(row.id)"><i
                    class="el-icon-delete"></i> 删除</l-auth-text-button>
              </template>
            </el-table-column>
          </l-table>

          <l-table :data="data" v-loading="loading" row-key="id" v-if="this.org_id != -1">
            <el-table-column v-for="(item, index) in columns" :key="index" v-bind="{ ...item }" :label="item.label"
              show-overflow-tooltip>

              <template v-slot="{ row }">

                <template v-if="item.prop == 'app_name'">
                  <el-tag size="small" type="success" disable-transitions v-for="(item, idx) in row.app_name" :key="idx">
                    {{ item }}
                  </el-tag>
                </template>

              <template v-else-if="item.prop == 'state'">
                <el-tag :type="row.state == STATES.enabled ? 'success' : 'danger'" size="small" disable-transitions>{{
                  STATE_NAMES[row.state] }}</el-tag>
                </template>
                <!-- <template v-else-if="item.prop == 'mobile'">
                        {{ phoneFormat(row.mobile) }}
                      </template> -->
                <template v-else>
                  {{ row[item.prop] }}
                </template>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="230" align="center">
              <template slot-scope="{ row }">

                <l-auth-text-button type="primary" auth="admin_user_edit_btn" @click="showEdit(row.id)"><i
                    class="el-icon-edit"></i>修改密码</l-auth-text-button>

                <l-auth-text-button type="primary" auth="allocate_info_btn" @click="showInfoPosition(row.id)"><i
                    class="el-icon-warning-outline"></i>调配</l-auth-text-button>

                <l-auth-text-button type="danger" auth="admin_user_del_btn" @click="del(row.id)"><i
                    class="el-icon-delete"></i> 删除</l-auth-text-button>
                  
              </template>
            </el-table-column>
          </l-table>

          <!--分页-->
          <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size"
            :current-page.sync="page"></l-page>
        </div>
      </div>
    </div>

    <!--调配-->
    <l-dialog :visible.sync="info_position_visible" title="调配" width="1200px">
      <l-user-info-position @on-success="positionCG" :visible.sync="info_position_visible" :id="info_id" />
    </l-dialog>

    <!--添加-->
    <l-dialog :visible.sync="add_visible" title="创建" width="1000px">
      <l-user-edit @on-success="onAddSucess" :visible.sync="add_visible" :org_id="org_id" />
    </l-dialog>
<!-- 
    <l-dialog :visible.sync="edit_visible" title="编辑" width="1000px">
      <l-user-edit @on-success="onEditSuccess" :visible.sync="edit_visible" :id="edit_id" />
    </l-dialog> -->

    <!--修改密码-->
    <l-dialog :visible.sync="change_pwd_visible" title="修改密码">
      <user-change-pwd @on-success="onChangePwdSuccess" :visible.sync="change_pwd_visible" :id="edit_id" />
    </l-dialog>

    <!--详情-->
    <l-dialog :visible.sync="info_visible" title="详情" width="1100px">
      <l-user-edit :visible.sync="info_visible" :id="info_id" is-info />
    </l-dialog>
  </el-card>
</template>

<script>
import Vue from "vue";
import Edit from "./Edit";
import PositionInfo from "../userPosition/Info.vue"
import UserChangePwd from "@/views/user/ChangePwd";
// import { emailFormat, phoneFormat } from "@/utils/Fuc";
import { STATES, STATE_NAMES } from "@/common/constants/resources";
import OrgList from "../org/List.vue";
let columns = [
  {
    prop: "index",
    label: "序号",
    fixed: true,
    width: "80",
  },
  {
    prop: "state",
    label: "状态",
    fixed: false,
    minWidth: "80",
  },
  {
    prop: "id",
    label: "员工Id",
    fixed: false,
    minWidth: "110",
  },
  {
    prop: "name",
    label: "员工名",
    fixed: true,
    width: "110",
  },
  {
    prop: "username",
    label: "员工账号",
    fixed: false,
    minWidth: "120",
  },

  {
    prop: "today_invite",
    label: "今日邀请",
    fixed: false,
    minWidth: "100",
  },
  {
    prop: "corp_name",
    label: "所属公司",
    fixed: false,
    minWidth: "130",
  },
  {
    prop: "depart_name",
    label: "所属部门",
    fixed: false,
    minWidth: "130",
  },
  {
    prop: "group_name",
    label: "所属小组",
    fixed: false,
    minWidth: "130",
  },
  {
    prop: "app_name",
    label: "应用",
    fixed: false,
    minWidth: "110",
  },
  {
    prop: "commission_model_name",
    label: "模式",
    fixed: false,
    minWidth: "100",
  },

  {
    prop: "role_name",
    label: "员工角色",
    fixed: false,
    minWidth: "120",
  },

  {
    prop: "room_code",
    label: "房间id",
    fixed: false,
    minWidth: "100",
  },
  {
    prop: "created_at",
    label: "添加时间",
    fixed: false,
    minWidth: "150",
  },
];


let columnsAdmin = [
  {
    prop: "index",
    label: "序号",
    fixed: true,
    width: "80",
  },
  {
    prop: "state",
    label: "状态",
    fixed: false,
    minWidth: "100",
  },
  {
    prop: "id",
    label: "员工Id",
    fixed: false,
    minWidth: "120",
  },
  {
    prop: "username",
    label: "员工名",
    fixed: true,
    width: "140",
  },
  {
    prop: "corp_name",
    label: "管理公司",
    fixed: false,
    minWidth: "150",
  },
  {
    prop: "depart_name",
    label: "管理部门",
    fixed: false,
    minWidth: "150",
  },
  {
    prop: "group_name",
    label: "管理小组",
    fixed: false,
    minWidth: "150",
  },
  {
    prop: "app_name",
    label: "管理应用",
    fixed: false,
    minWidth: "110",
  },

  {
    prop: "role_name",
    label: "员工角色",
    fixed: false,
    minWidth: "120",
  },
  {
    prop: "created_at",
    label: "添加时间",
    fixed: false,
    minWidth: "180",
  },
];



export default {
  name: "admin-user",
  components: {
    [Edit.name]: Edit,
    [UserChangePwd.name]: UserChangePwd,
    [OrgList.name]: OrgList,
    [PositionInfo.name]: PositionInfo
  },
  data() {
    return {
      org_id_state: 200,
      data: [],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,
      info_position_visible:false,
      add_visible: false, //是否显示添加

      edit_visible: false, //是否显示编辑
      edit_id: 0,

      info_visible: false, //是否显示编辑
      info_id: 0,
      // 获取部门id
      org_id: 0,
      change_pwd_visible: false, //是否显示修改密码
      change_pwd_id: 0,
      STATE_NAMES: STATE_NAMES,
      STATES: STATES,
      //搜索
      search_visible: false,
      search_loading: true,
      site_tree: [],
      role_list: [],
      search_data: {
        keywords: "",
        name: "",
        mobile: "",
        email: "",
        site_id: undefined,
        role_id: "",
      },

      rel_search_data: {},
      show_more_search: false,

      re_fixed_list: [],
      fixed_list: [],
    };
  },

  computed: {
    columns() {
      let result = [];
      if (this.org_id == -1) {
        // this.org_id_state = 100;
        result = columnsAdmin.map((item) => {
          const index = this.fixed_list.findIndex((itm) => {
            return itm == item.prop;
          });
          if (index != -1) {
            item.fixed = true;
            if (!item.width) {
              item.width = item.minWidth;
            }
          } else {
            if (item.minWidth && item.width) {
              delete item.width;
            }
            item.fixed = false;
          }

          return item;
        });
      } else {
        // this.org_id_state = 200;
        result = columns.map((item) => {
          const index = this.fixed_list.findIndex((itm) => {
            return itm == item.prop;
          });
          if (index != -1) {
            item.fixed = true;
            if (!item.width) {
              item.width = item.minWidth;
            }
          } else {
            if (item.minWidth && item.width) {
              delete item.width;
            }
            item.fixed = false;
          }

          return item;
        });
      }
      return result;
    },
  },

  watch: {
    fixed_list(val) {
      if (val.length > 3) {
        this.fixed_list.shift();
      }
    },
  },

  methods: {
    showInfoPosition(id) {
      this.info_id = id;
      this.$nextTick(() => {
        this.info_position_visible = true;
      });
    },
    //调配完成 
    positionCG() {
      this.info_position_visible = false;
    },
    //加载列表方法
    aftercheckOrg(org_id) {
      // 赋值到 添加页码
      this.org_id = org_id;
      this.getList();
    },
    //获取数据
    getList() {
      this.loading = true;
      this.$_invoke("adminUser_getList", {
        page: this.page,
        page_size: this.page_size,
        org_id: this.org_id,
        ...this.rel_search_data,
      })
        .then((ret) => {
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //获取搜索数据
    getSearchData() {
      this.search_loading = true;
      this.$_invoke("adminUser_getSearchData")
        .then((ret) => {
          this.site_tree = ret.site_tree;
          this.role_list = ret.role_list;
        })
        .finally(() => {
          this.search_loading = false;
        });
    },

    //显示搜索
    showSearch() {
      this.search_visible = true;
      this.getSearchData();
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //显示详情
    showInfo(id) {
      // console.log(id);
      this.info_id = id;
      this.$nextTick(() => {
        this.info_visible = true;
      });
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //修改状态
    changeState(row) {
      // console.log(row.id);
      this.change_state_loading.push(row.id);

      this.$_invoke(`adminUser_updState`, {
        id: row.id,
        state: row.state,
      })
        .then((ret) => {
          row.state = ret.state;
          this.$_msg.success("修改状态成功");
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => { });
    },

    //添加成功回调
    onAddSucess() {
      this.add_visible = false;
      this.getList();
    },

    //显示修改界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.change_pwd_visible = true;
      });
    },

    //编辑成功回调
    onEditSuccess() {
      this.edit_visible = false;
      this.getList();
    },

    //显示修改密码界面
    showChangePwd(id) {
      this.change_pwd_id = id;
      this.$nextTick(() => {
        this.change_pwd_visible = true;
      });
    },

    //修改密码成功回掉
    onChangePwdSuccess() {
      this.change_pwd_visible = false;
      this.getList();
    },

    //删除
    del(id) {
      console.log(id);
      this.$confirm(
        "确定删除该条记录吗" + "？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$_invoke(`adminUser_delete`, {id: id}).then(() => {
            this.$_msg.success("删除成功");
            this.getList();
          });
        })
        .catch(() => { });
    },

    //重置固定栏位选择
    resetFixedCheck() {
      this.fixed_list = JSON.parse(JSON.stringify(this.re_fixed_list));
    },
  },
};
</script>